const breadcrumb = {
  missions: 'Liste de missions',
  new: 'Profil de mission',
  details: 'Profil de mission',
  reupload: '',
};

const button = {
  backToList: 'Retour à la liste',
  downloadMissionProfile: 'Télécharger le profil de mission',
  downloadMissionConfiguration: 'Télécharger la configuration de mission',
  updateMission: 'Mettre à jour la mission',
  uploadMissionConfiguration: 'Téléverser la configuration de mission',
  uploadNewMission: 'Charger une nouvelle mission',
};

const details = {
  airports: 'Aéroports',
  centerlines: 'Lignes de centre',
  jurisdictions: 'Juridictions',
  length: 'Distance',
  loadingAirports: 'Chargement des aéroports',
  loadingObstacles: 'Chargement des obstacles',
  name: 'Nom',
  obstacles: 'Obstacles',
  pipelineCenterline: 'Ligne de centre du pipeline',
  rightOfWay: 'Servitude',
  rightOfWays: 'Servitudes',
  routes: 'Routes',
  urbanArea: 'Zone restreinte',
  urbanAreas: 'Zones restreintes',
  workzone: 'Zone de construction',
  workzones: 'Zones de construction',
};

const message = {
  creationSuccess: 'Mission créée avec succès',
  deletionConfirmation: 'Voulez-vous supprimer cette mission?',
  invalidPhoneNumberFormat: 'Format de numéro de téléphone non valide',
  updateSuccess: 'Mission modifiée avec succès',
  uploadPrompt: 'Veuillez charger un fichier de configuration de mission',
  uploadSuccess: 'Fichier chargé avec succès',
  sharedRow: 'Cette mission contient des lignes partagées',
};

const table = {
  email: 'Courriel',
  id: 'ID',
  name: 'Nom',
  phone: 'Téléphone',
};

export default {
  breadcrumb,
  contactsPerJurisdictions: 'Contacts par Juridiction',
  createMission: 'Créer mission',
  createSharedMission: 'Créer une mission partagée',
  id: 'Id',
  name: 'Nom de mission',
  daysSinceFlown: 'Jours depuis le vol',
  notFlown: 'Non effectué',
  sharedROW: 'Mission partagée',
  removeObstacles: 'Enlever les obstacles',
  button,
  details,
  editContactInformation: 'Modifier les informations de la juridiction',
  newMission: 'Nouvelle mission',
  message,
  missionDetails: 'Détails de la mission',
  missionValidated: 'Mission validée',
  table,
};
